import { render } from "./Home.vue?vue&type=template&id=3dd68e71&scoped=true&bindings={}"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=3dd68e71&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3dd68e71"

export default script